const Routing = require('fosRouterSrc')
const routes = require('./routes.json')

Routing.setRoutingData(routes)

module.exports = Routing
